export const REACT_APP_CLIENT_URL = process.env.REACT_APP_CLIENT_URL ?? '';
export const REACT_APP_SERVER_URL = process.env.REACT_APP_SERVER_URL ?? '';